module.exports = __webpack_public_path__ + "img/SES_235415300.c0fa2d71.jpg";